import { useMount } from 'shared/src/hooks';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogViewFindId = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useMount(() => {
    logAnalyticsEvent({
      name: 'VIEW_FIND_ID',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  });
};
